import React, { useEffect, useRef, useState } from 'react';
import MiniLoader from '../../layout2.0/UI/MiniLoader';
import { CMSPath, globalIV, globalSalt } from '../../config/constant';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { currentWidget } from '../../action/action';
import { AesUtil } from '../../JS/AesUtil';

const HomescreenIframeRenderer = (props) => {

  const { widgetList, currentWidget, history } = props
  const iframeRef = useRef(null);

  let aesUtil = new AesUtil(128, 1000);

  const [initialLoading, setInitialLoading] = useState(true);
  const [guestDetails, setGuestDetails] = useState({});

  // Helper to parse guest details from storage
  const fetchGuestDetails = () => {
    try {
      const guestDetailsFromLocalStorage = localStorage.getItem("Set_Current_Logged_In_Guest_Details");
      if (guestDetailsFromLocalStorage) {
        return JSON.parse(guestDetailsFromLocalStorage)[0];
      }

      const encryptedData = localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA");
      if (encryptedData) {
        return JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567", encryptedData));
      }
    } catch (error) {
      console.error("Error fetching guest details:", error);
    }
    return {};
  };

  const heightEventTrigger = (message ) =>{
    if(!iframeRef && !iframeRef.current) return;
    if(message.source !== iframeRef.current.contentWindow) return;

    if(message.data && message.data.type == "HEIGHT"){
      const height = message.data.height;
      
      console.log("heightEventTrigger",resolvedUrl , message.data.height )
      if(iframeRef && iframeRef.current) iframeRef.current.style.height = `${height}px`;
    }
  }

  useEffect(() => {
    // Fetch guest details on mount
    setGuestDetails(fetchGuestDetails());
    window.addEventListener("message", heightEventTrigger)

    return ()=>{
      window.removeEventListener("message", heightEventTrigger)
    }
  }, []);

  let targetUrl = null;
  if (widgetList && widgetList[0] && widgetList[0].targetUrl) {
    targetUrl = widgetList[0].targetUrl;
  }

  let resolvedUrl = null;
  if (targetUrl) {
    resolvedUrl = targetUrl.startsWith("http")
      ? targetUrl.replace("#RESERVATION_ID", guestDetails.reservationNumber || "")
      : CMSPath + targetUrl.replace("#RESERVATION_ID", guestDetails.reservationNumber || "");
  }

  return targetUrl ? (
    <div className={`homepage-iframe-container ${widgetList[0] && widgetList[0].widgetMetaHtmlId || ""}`} >
      {initialLoading && <MiniLoader />}
      <iframe
        ref={iframeRef}
        src={resolvedUrl}
        onLoad={() => setInitialLoading(false)}
        className="homepage-iframe"
        style={{ display: initialLoading ? "none" : "block" }}
      ></iframe>
    </div>
  ) : null;
};

const mapStateToProps = state => {
  return {}
}

export default connect(mapStateToProps, { currentWidget })(
  withTranslation("translations")(withRouter(HomescreenIframeRenderer))
);
